import { useMemo } from "react";
import ReactQuill from "react-quill";

import classNames from "common/class-names";

import { AppEditorDto } from "dto/components/app-editor-dto";

const AppEditor = ({ label, onChange, value, error, touched, required, placeholder }: AppEditorDto) => {
	const isInvalid = useMemo(() => Boolean(error) && Boolean(touched), [error, touched]);
	const inputClassNames = useMemo(() => classNames({ editor: true, "editor--error": isInvalid }), [isInvalid]);

	//prettier-ignore
	const modules = useMemo(() => ({
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "link"],
            [{ list: "ordered" }, { list: "bullet" }]
        ]
    }), []);

	return (
		<div className="app-editor">
			<div className={inputClassNames}>
				{label && (
					<label className="editor__label">
						{label}

						{required && <span className="editor__required"> *</span>}
					</label>
				)}

				<div className="editor__container">
					<ReactQuill theme="snow" value={value} onChange={onChange} className="editor__input" modules={modules} placeholder={placeholder} />
				</div>

				{isInvalid && <div className="editor__text-error">{error}</div>}
			</div>
		</div>
	);
};

export default AppEditor;
